import {
  StepName,
  PresetName,
  PredefinedPresetName,
  CustomPresetParamName,
  OverlayPlacementName,
  ExportQualityName,
  ExportFormatName,
  Config,
  TextPresetName,
} from '../types';

export const WIDGET_UPDATE_DEBOUNCE_WAIT_TIME = 500;

export const STEPS: StepName[] = ['resizeAndCrop', 'imageOverlay', 'textOverlays', 'export'];
export const PREDEFINED_PRESETS: PredefinedPresetName[] = ['original', 'square', 'landscape-16:9', 'landscape-4:3', 'portrait-3:4', 'portrait-9:16'];
export const PRESETS: PresetName[] = [...PREDEFINED_PRESETS, 'custom'];
export const CUSTOM_PRESET_MAX_SIZE = 10000;
export const CUSTOM_PRESET_PARAMS: CustomPresetParamName[] = ['label', 'width', 'height'];
export const OVERLAY_PLACEMENTS: OverlayPlacementName[] = ['top_left', 'top_right', 'bottom_left', 'bottom_right', 'middle'];
export const EXPORT_QUALITIES: ExportQualityName[] = ['auto', 'best', 'good', 'eco', 'low'];
export const EXPORT_FORMATS: ExportFormatName[] = ['jpg', 'png', 'webp'];
export const TEXT_PRESETS: TextPresetName[] = ['heading', 'subtitle', 'body', 'caption'];

export const DEFAULT_CONFIG: Config = {
  cloudName: 'product-demos',
  themesPath: 'mew',
  themes: [
    {
      name: 'Travel',
      assets: ['01', '02', '03', '04', '05', '06'],
      logos: ['01', '02', '03', '04'],
      overlays: ['01', '02', '03', '04'],
    }, {
      name: 'Food',
      assets: ['01', '02', '03', '04', '05', '06'],
      logos: ['01', '02', '03', '04'],
      overlays: ['01', '02', '03', '04'],
    }, {
      name: 'Fashion',
      assets: ['01', '02', '03', '04', '05', '06'],
      logos: ['01', '02', '03', '04'],
      overlays: ['01', '02', '03', '04'],
    }, {
      name: 'Technology',
      assets: ['01', '02', '03', '04', '05', '06'],
      logos: ['01', '02', '03', '04'],
      overlays: ['01', '02', '03', '04'],
    },
  ],
};
